import apiClient from './client';

export interface CustomFieldDefinition {
  id: number;
  entity_type: string;
  field_name: string;
  field_type: string;
  label: string;
  is_required: boolean;
  default_value?: string;
  options?: string[];
  validation_rules?: any;
  created_at: string;
  updated_at: string;
}

export interface CustomFieldValue {
  id: number;
  entity_type: string;
  entity_id: number;
  field_definition_id: number;
  value: any;
  created_at: string;
  updated_at: string;
}

export const customFieldsApi = {
  getDefinitions: async (entityType: string): Promise<CustomFieldDefinition[]> => {
    const response = await apiClient.get<{ success: boolean; data: CustomFieldDefinition[] }>(`/custom-fields/definitions/${entityType}`);
    return response.data.data;
  },
  getDefinitionById: async (id: number): Promise<CustomFieldDefinition> => {
    const response = await apiClient.get<{ success: boolean; data: CustomFieldDefinition }>(`/custom-fields/definitions/${id}`);
    return response.data.data;
  },
  createDefinition: async (definition: Partial<CustomFieldDefinition>): Promise<CustomFieldDefinition> => {
    const response = await apiClient.post<{ success: boolean; data: CustomFieldDefinition }>('/custom-fields/definitions', definition);
    return response.data.data;
  },
  updateDefinition: async (id: number, definition: Partial<CustomFieldDefinition>): Promise<CustomFieldDefinition> => {
    const response = await apiClient.patch<{ success: boolean; data: CustomFieldDefinition }>(`/custom-fields/definitions/${id}`, definition);
    return response.data.data;
  },
  deleteDefinition: async (id: number): Promise<void> => {
    await apiClient.delete(`/custom-fields/definitions/${id}`);
  },
  getValues: async (entityType: string, entityId: number): Promise<Record<string, any>> => {
    const response = await apiClient.get<{ success: boolean; data: Record<string, any> }>(`/custom-fields/values/${entityType}/${entityId}`);
    return response.data.data;
  },
  setValue: async (entityType: string, entityId: number, fieldDefinitionId: number, value: any): Promise<CustomFieldValue> => {
    const response = await apiClient.post<{ success: boolean; data: CustomFieldValue }>(`/custom-fields/values`, {
      entity_type: entityType,
      entity_id: entityId,
      field_definition_id: fieldDefinitionId,
      value,
    });
    return response.data.data;
  },
  setValues: async (entityType: string, entityId: number, values: Record<string, any>): Promise<void> => {
    await apiClient.post('/custom-fields/values/bulk', {
      entity_type: entityType,
      entity_id: entityId,
      values,
    });
  },
};
